import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, Icon, message, Upload } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import numeral from "numeral";
import ProdutoTamanhoFrame from './ProdutoTamanhoFrame';
import ProdutoCorFrame from './ProdutoCorFrame';
import GrupoProdutoFrame from './GrupoProdutoFrame';
import MarcaFrame from './MarcaFrame';
import MedidaFrame from './MedidaFrame';

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('Você só pode enviar arquivos JPG / PNG!');
  }
  const isLt2M = file.size / 1024 / 1024 < 0.1;
  if (!isLt2M) {
    message.error('A imagem deve ter menos de 100 KB!');
  }
  return isJpgOrPng && isLt2M;
}


export default class ProdutoForm extends Component {
  state = {
    registro: {
      prod_idf: 0,
      prod_codigo: '0',
      prod_grade: 0,
      prod_controla_estoque: 1,
      prod_flag_catalogo: 0,
      prod_grupo: { key: '0' },
      prod_marca: { key: '0' },
      prod_medida: { key: '0' },
      listaGrade: [],

      imgNome: '',
      imgSize: '0',
      imgData: '',
      base64: '',
      pathImagem: null,
    },
    registroGrade: {
      pest_tamanho: { key: '0', label: '', },
      pest_cor: { key: '0', label: '', },
      pest_qtde: 0,
      pest_est_minimo: 0,
    },
    activeKey: "dados",
    carregandoGrade: false,
  };


  componentDidMount() {

  }

  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {

      this.state.registro = this.props.registroSelecionado.data.dados;

      this.setState({
        registro: {
          ...this.state.registro,
          prod_flag_catalogo: this.state.registro.prod_flag_catalogo === '1' ? 1 : 0,
          listaGrade: [],
        },
        listaGrade: this.props.registroSelecionado.data.listaGrade ? this.props.registroSelecionado.data.listaGrade : [],
        visualizar: this.props.registroSelecionado.visualizar,
        activeKey: "dados",
      }, () => {
        this.calculoMargem(this.props.registroSelecionado.prod_vlr_custo, this.props.registroSelecionado.prod_vlr_venda);
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangeGrupoProduto = event => {
    const { registro } = this.state;
    registro['prod_grupo'] = event.prod_grupo;
    this.setState(event);
  }

  onChangeMarcaProduto = event => {
    const { registro } = this.state;
    registro['prod_marca'] = event.prod_marca;
    this.setState(event);
  }

  onChangeMedidaProduto = event => {
    const { registro } = this.state;
    registro['prod_medida'] = event.prod_medida;
    this.setState(event);
  }

  onChangeControlaEstoque = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    registro.prod_qtde_atual = 0;
    registro.prod_est_minimo = 0;
    registro.prod_grade = 0;
    this.setState({
      [id]: value
    });
  };

  onChangeGrade = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    registro.prod_qtde_atual = 0;
    registro.prod_est_minimo = 0;
    registro.prod_controla_estoque = 1;
    this.setState({
      [id]: value
    });
  };

  onChangeVlrCusto = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    const { prod_vlr_venda } = this.state.registro;
    this.calculoMargem(value, prod_vlr_venda);
  };

  onChangeVlrVenda = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    const { prod_vlr_custo } = this.state.registro;
    this.calculoMargem(prod_vlr_custo, value);
  };

  onChangeMargem = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    const { prod_vlr_custo } = this.state.registro;
    this.calculoVlrVenda(prod_vlr_custo, value);
  };


  calculoMargem = (prod_vlr_custo, prod_vlr_venda) => {
    const { registro } = this.state;
    let vlrCusto = parseFloat(prod_vlr_custo);
    let vlrVenda = parseFloat(prod_vlr_venda);
    registro.prod_vlr_margem = vlrCusto ? parseFloat(((vlrVenda / vlrCusto) - 1) * 100) : 0;
    this.setState({
      registro
    });
  }
  calculoVlrVenda = (prod_vlr_custo, prod_vlr_margem) => {
    const { registro } = this.state;
    let vlrCusto = parseFloat(prod_vlr_custo);
    let vlrMargem = parseFloat(prod_vlr_margem);
    registro.prod_vlr_venda = vlrCusto && vlrCusto ? parseFloat(((vlrCusto + (vlrCusto * (vlrMargem / 100))))) : 0;
    this.setState({
      registro
    });
  }



  onOK = () => {
    if ((!this.state.registro.prod_descricao) || (this.state.registro.prod_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    if ((!this.state.registro.prod_grupo) || (this.state.registro.prod_grupo.key === '0') || (this.state.registro.prod_grupo.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Grupo', });
      return;
    }
    if ((!this.state.registro.prod_marca) || (this.state.registro.prod_marca.key === '0') || (this.state.registro.prod_marca.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Marca', });
      return;
    }
    if ((!this.state.registro.prod_medida) || (this.state.registro.prod_medida.key === '0') || (this.state.registro.prod_medida.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Unidade de Medida', });
      return;
    }

    if ((this.state.registro.prod_grade) && (this.state.registro.prod_grade !== 0) && (!this.state.listaGrade) && (this.state.listaGrade.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Inclua alguma grade', });
      return;
    }

    const reg = {
      ...this.state.registro,
      prod_cod_original: this.state.registro.prod_cod_original ? String(this.state.registro.prod_cod_original) : '',
      prod_cod_barras: this.state.registro.prod_cod_barras ? this.state.registro.prod_cod_barras.toUpperCase().replace(/[^A-Z0-9]/g, '') : '',
      prod_ncm: this.state.registro.prod_ncm ? String(this.state.registro.prod_ncm).toUpperCase().replace(/[^A-Z0-9]/g, '') : '',
      prod_grupo: this.state.registro.prod_grupo.key,
      prod_marca: this.state.registro.prod_marca.key,
      prod_medida: this.state.registro.prod_medida.key,
      listaGrade: this.state.listaGrade,
    }


    this.props.onSalvarClick(reg);
  };


  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  handleChange = info => {
    // console.log('handleChange: ', info);

    const isJpgOrPng = info.file.type === 'image/jpeg' || info.file.type === 'image/png';
    if (!isJpgOrPng) {
      return;
    }
    const isLt2M = info.file.size / 1024 / 1024 < 0.1;
    if (!isLt2M) {
      return;
    }

    this.setState({
      registro: {
        ...this.state.registro,
        imgNome: '',
        imgSize: '',
        imgData: '',
        pathImagem: '',
        base64: '',
      },
    });

    getBase64(info.file.originFileObj, imageUrl =>
      this.setState({
        registro: {
          ...this.state.registro,
          imgNome: info.file.name,
          imgSize: info.file.size,
          imgData: info.file.lastModifiedDate,
          pathImagem: '',
          base64: imageUrl,
        },
        loading: false,
      }),
    );
  };



  onChangeQtdeGrade = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroGrade } = this.state;
    registroGrade[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangeTamanho = event => {
    const { registroGrade } = this.state;
    registroGrade['pest_tamanho'] = event.pest_tamanho;
    this.setState(event);
  }

  onChangeCor = event => {
    const { registroGrade } = this.state;
    registroGrade['pest_cor'] = event.pest_cor;
    this.setState(event);
  }


  onFormIncluirGrade = () => {
    const { pest_tamanho, pest_cor, pest_qtde, pest_est_minimo } = this.state.registroGrade;

    if ((!pest_tamanho) || (pest_tamanho.key === '0') || (pest_tamanho.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tamanho', });
      return;
    }

    if ((!pest_cor) || (pest_cor.key === '0') || (pest_cor.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Cor', });
      return;
    }


    let iIndItem = -1;
    for (var x in this.state.listaGrade) {
      if ((String(this.state.listaGrade[x].pest_tamanho) === String(pest_tamanho.key)) && (String(this.state.listaGrade[x].pest_cor) === String(pest_cor.key))) {
        iIndItem = x;
      }
    }

    if (iIndItem >= 0) {
      Modal.warning({ title: 'Aviso!', content: 'Grade já Formada', });
      return;
    } else {
      this.state.listaGrade.push({
        pest_item: 0,
        pest_tamanho: pest_tamanho.key,
        ptam_descricao: pest_tamanho.label,
        pest_cor: pest_cor.key,
        pcor_descricao: pest_cor.label,
        pest_qtde: pest_qtde ? parseFloat(pest_qtde) : 0,
        pest_est_minimo: pest_est_minimo ? parseFloat(pest_est_minimo) : 0,
      });
    }
    this.setState({
      listaGrade: this.state.listaGrade,
      registroGrade: {
        pest_tamanho: { key: '0', label: '', },
        pest_cor: { key: '0', label: '', },
        pest_qtde: 0,
        pest_est_minimo: 0,
      },
    });
  }

  onExcluirGradeClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este produto?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaGrade = [...this.state.listaGrade];
        const index = listaGrade.findIndex(registro => registro.pest_tamanho + '_' + registro.pest_cor === reg.pest_tamanho + '_' + reg.pest_cor);

        listaGrade.splice(index, 1);

        this.setState({
          listaGrade,
        });
      }
    })
  }




  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };


  renderAcoesGrade = (registro) => {
    return (
      <Tooltip title="Excluir">
        <Button type="danger" size="small" onClick={() => this.onExcluirGradeClick(registro)} icon="delete" disabled={registro.pest_item} />
      </Tooltip>
    );
  };


  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { listaGrade, carregandoGrade } = this.state;
    const { pest_tamanho, pest_cor, pest_qtde, pest_est_minimo } = this.state.registroGrade;
    const { prod_idf, prod_codigo, prod_cod_original, prod_descricao, prod_cod_barras, prod_ncm,
      prod_grade, prod_controla_estoque, prod_flag_catalogo, prod_qtde_atual, prod_est_minimo, prod_vlr_custo,
      prod_vlr_venda, prod_vlr_venda_min, prod_vlr_margem, prod_grupo, prod_marca, prod_medida,
      base64, pathImagem } = this.state.registro;

    // console.log('ProdutoForm.this.state', this.state);

    const uploadButton = (
      <div>
        {this.state.loading ? <Icon type="loading" style={{ color: 'rgba(0,0,0,0.4)' }} /> : <Icon type="plus" style={{ color: 'rgba(0,0,0,0.4)' }} />}
        <div className="ant-upload-text">Imagem</div>
      </div>
    );

    return (
      <Modal
        title={prod_codigo ? "Edição de Produto" : "Cadastro de Produto"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 30 }}
      >
        <div>
          {!prod_grade ? (
            <Form>
              <Row>
                <Col xs={24} sm={4} className="camposEspacoDireita">
                  <span>Código</span>
                  <InputForm
                    id="prod_codigo"
                    value={prod_codigo}
                    readOnly
                  />
                </Col>

                <Col xs={24} sm={4} className="camposEspacoDireita">
                  <span>Cód Orig</span>
                  <InputForm
                    id="prod_cod_original"
                    ref="prod_cod_original"
                    maxLength={20}
                    onChange={this.onChange}
                    value={prod_cod_original}
                    validator={value => Boolean(value)}
                  />
                </Col>

                <Col xs={24} sm={16}>
                  <span>Descrição *</span>
                  <InputForm
                    id="prod_descricao"
                    ref="prod_descricao"
                    maxLength={60}
                    onChange={this.onChange}
                    value={prod_descricao}
                    validator={value => Boolean(value)}
                  />
                </Col>

                <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Código Barras</span>
                  <InputForm
                    id="prod_cod_barras"
                    ref="prod_cod_barras"
                    maxLength={20}
                    onChange={this.onChange}
                    value={prod_cod_barras}
                    validator={value => Boolean(value)}
                  />
                </Col>

                <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Grupo *</span>
                  <GrupoProdutoFrame
                    label=""
                    id="prod_grupo"
                    value={prod_grupo}
                    width={"100%"}
                    onChange={this.onChangeGrupoProduto}
                    descricaoPrimeiroItem="Selecione um grupo"
                  />
                </Col>

                <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                  <MarcaFrame
                    label="Marca *"
                    id="prod_marca"
                    value={prod_marca}
                    width={"100%"}
                    onChange={this.onChangeMarcaProduto}
                    descricaoPrimeiroItem="Selecione uma Marca"
                  />
                </Col>

                <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <MedidaFrame
                    label="Unidade Medida *"
                    id="prod_medida"
                    value={prod_medida}
                    width={"100%"}
                    onChange={this.onChangeMedidaProduto}
                    descricaoPrimeiroItem="Selecione"
                  />
                </Col>

                <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>NCM</span>
                  <InputForm
                    id="prod_ncm"
                    ref="prod_ncm"
                    maxLength={20}
                    onChange={this.onChange}
                    value={prod_ncm}
                    validator={value => Boolean(value)}
                  />
                </Col>

                <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Qtde Estoque</span>
                  <InputForm
                    type="number"
                    id="prod_qtde_atual"
                    ref="prod_qtde_atual"
                    value={prod_qtde_atual}
                    onChange={this.onChange}
                    disabled={!prod_controla_estoque ? true : (prod_idf ? true : false)}
                  />
                </Col>

                <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                  <span>Estoque Mínimo</span>
                  <InputForm
                    type="number"
                    id="prod_est_minimo"
                    ref="prod_est_minimo"
                    value={prod_est_minimo}
                    onChange={this.onChange}
                    disabled={!prod_controla_estoque ? true : (prod_idf ? true : false)}
                  />
                </Col>

                <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Vlr Custo</span>
                  <InputForm
                    type="number"
                    id="prod_vlr_custo"
                    ref="prod_vlr_custo"
                    value={prod_vlr_custo}
                    onChange={this.onChangeVlrCusto}
                  />
                </Col>

                <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Vlr Venda</span>
                  <InputForm
                    type="number"
                    id="prod_vlr_venda"
                    ref="prod_vlr_venda"
                    value={prod_vlr_venda}
                    onChange={this.onChangeVlrVenda}
                  />
                </Col>

                <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                  <span>Vlr Venda Min</span>
                  <InputForm
                    type="number"
                    id="prod_vlr_venda_min"
                    ref="prod_vlr_venda_min"
                    value={prod_vlr_venda_min}
                    onChange={this.onChange}
                  />
                </Col>

                <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                  <span>% Margem Lucro</span>
                  <InputForm
                    type="number"
                    id="prod_vlr_margem"
                    ref="prod_vlr_margem"
                    value={prod_vlr_margem}
                    onChange={this.onChangeMargem}
                  />
                </Col>

                <Col xs={24} sm={6} style={{ marginTop: -30 }} className="campoCheckBox">
                  <InputForm
                    type="checkbox"
                    id="prod_flag_catalogo"
                    ref="prod_flag_catalogo"
                    onChange={this.onChange}
                    value={prod_flag_catalogo}
                  >
                    Mostrar no Catálogo
                  </InputForm>
                </Col>

                <Col xs={24} sm={6} style={{ marginTop: -30 }} className="campoCheckBox">
                  <InputForm
                    type="checkbox"
                    id="prod_controla_estoque"
                    ref="prod_controla_estoque"
                    onChange={this.onChangeControlaEstoque}
                    value={prod_controla_estoque}
                    disabled={prod_idf ? true : false}
                  >
                    Controla Estoque
                  </InputForm>
                </Col>

                <Col xs={24} sm={6} style={{ marginTop: -30 }} className="campoCheckBox">
                  <InputForm
                    type="checkbox"
                    id="prod_grade"
                    ref="prod_grade"
                    onChange={this.onChangeGrade}
                    value={prod_grade}
                    disabled={prod_idf || !prod_controla_estoque ? true : false}
                  >
                    Estoque em Grade
                  </InputForm>
                </Col>

                <Tooltip title="Carregar Imagem" placement="topLeft">
                  <Col xs={24} sm={6} style={{ marginTop: 0, paddingLeft: 50 }}>
                    <Upload
                      name="avatar"
                      listType="picture-card"
                      className="avatar-uploader"
                      showUploadList={false}
                      beforeUpload={beforeUpload}
                      onChange={this.handleChange}
                    >
                      {base64 || pathImagem ? <img src={base64 ? base64 : pathImagem} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                    </Upload>
                  </Col>
                </Tooltip>

              </Row>
            </Form>

          ) : (

            <div>
              <Tabs
                type="card"
                activeKey={this.state.activeKey}
                onChange={this.onChangeTabs}
              >
                <TabPane tab="Dados Principais" key="dados">
                  <div style={{ height: 270 }}>

                    <Form>
                      <Row>
                        <Col xs={24} sm={4} className="camposEspacoDireita">
                          <span>Código</span>
                          <InputForm
                            id="prod_codigo"
                            value={prod_codigo}
                            readOnly
                          />
                        </Col>

                        <Col xs={24} sm={4} className="camposEspacoDireita">
                          <span>Cód Orig</span>
                          <InputForm
                            id="prod_cod_original"
                            ref="prod_cod_original"
                            maxLength={20}
                            onChange={this.onChange}
                            value={prod_cod_original}
                            validator={value => Boolean(value)}
                          />
                        </Col>

                        <Col xs={24} sm={16}>
                          <span>Descrição</span>
                          <InputForm
                            id="prod_descricao"
                            ref="prod_descricao"
                            maxLength={60}
                            onChange={this.onChange}
                            value={prod_descricao}
                            validator={value => Boolean(value)}
                          />
                        </Col>

                        <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
                          <span>Código Barras</span>
                          <InputForm
                            id="prod_cod_barras"
                            ref="prod_cod_barras"
                            maxLength={20}
                            onChange={this.onChange}
                            value={prod_cod_barras}
                            validator={value => Boolean(value)}
                          />
                        </Col>

                        <Col xs={24} sm={8} style={{ marginTop: -20 }} className="camposEspacoDireita">
                          <span>Grupo</span>
                          <GrupoProdutoFrame
                            label="Grupo"
                            id="prod_grupo"
                            value={prod_grupo}
                            width={"100%"}
                            onChange={this.onChangeGrupoProduto}
                          />
                        </Col>

                        <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                          <MarcaFrame
                            label="Marca"
                            id="prod_marca"
                            value={prod_marca}
                            width={"100%"}
                            onChange={this.onChangeMarcaProduto}
                          />
                        </Col>

                        <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                          <MedidaFrame
                            label="Unidade Medida"
                            id="prod_medida"
                            value={prod_medida}
                            width={"100%"}
                            onChange={this.onChangeMedidaProduto}
                            descricaoPrimeiroItem="Selecione"
                          />
                        </Col>

                        <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                          <span>NCM</span>
                          <InputForm
                            id="prod_ncm"
                            ref="prod_ncm"
                            maxLength={20}
                            onChange={this.onChange}
                            value={prod_ncm}
                            validator={value => Boolean(value)}
                          />
                        </Col>

                        <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                          <span>Qtde Estoque</span>
                          <InputForm
                            type="number"
                            id="prod_qtde_atual"
                            ref="prod_qtde_atual"
                            value={prod_qtde_atual}
                            onChange={this.onChange}
                            disabled={true}
                          />
                        </Col>

                        <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                          <span>Estoque Mínimo</span>
                          <InputForm
                            type="number"
                            id="prod_est_minimo"
                            ref="prod_est_minimo"
                            value={prod_est_minimo}
                            onChange={this.onChange}
                            disabled={true}
                          />
                        </Col>

                        <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                          <span>Vlr Custo</span>
                          <InputForm
                            type="number"
                            id="prod_vlr_custo"
                            ref="prod_vlr_custo"
                            value={prod_vlr_custo}
                            onChange={this.onChangeVlrCusto}
                          />
                        </Col>

                        <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                          <span>Vlr Venda</span>
                          <InputForm
                            type="number"
                            id="prod_vlr_venda"
                            ref="prod_vlr_venda"
                            value={prod_vlr_venda}
                            onChange={this.onChangeVlrVenda}
                          />
                        </Col>

                        <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                          <span>Vlr Venda Min</span>
                          <InputForm
                            type="number"
                            id="prod_vlr_venda_min"
                            ref="prod_vlr_venda_min"
                            value={prod_vlr_venda_min}
                            onChange={this.onChange}
                          />
                        </Col>

                        <Col xs={24} sm={6} style={{ marginTop: -20, marginRight: 50 }} className="camposEspacoDireita">
                          <span>% Margem Lucro</span>
                          <InputForm
                            type="number"
                            id="prod_vlr_margem"
                            ref="prod_vlr_margem"
                            value={prod_vlr_margem}
                            onChange={this.onChangeMargem}
                          />
                        </Col>

                        <Tooltip title="Carregar Imagem" placement="topLeft">
                          <Col xs={24} sm={6} style={{ marginTop: 0, paddingLeft: 50 }}>
                            <Upload
                              name="avatar"
                              listType="picture-card"
                              className="avatar-uploader"
                              showUploadList={false}
                              beforeUpload={beforeUpload}
                              onChange={this.handleChange}
                            >
                              {base64 || pathImagem ? <img src={base64 ? base64 : pathImagem} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                            </Upload>
                          </Col>
                        </Tooltip>

                        <Col xs={24} sm={6} style={{ marginTop: -30 }} className="campoCheckBox">
                          <InputForm
                            type="checkbox"
                            id="prod_flag_catalogo"
                            ref="prod_flag_catalogo"
                            onChange={this.onChange}
                            value={prod_flag_catalogo}
                          >
                            Mostrar no Catálogo
                          </InputForm>
                        </Col>

                        <Col xs={24} sm={6} style={{ marginTop: -30 }} className="campoCheckBox">
                          <InputForm
                            type="checkbox"
                            id="prod_controla_estoque"
                            ref="prod_controla_estoque"
                            onChange={this.onChangeControlaEstoque}
                            value={prod_controla_estoque}
                            disabled={true}
                          >
                            Controla Estoque
                          </InputForm>
                        </Col>

                        <Col xs={24} sm={6} style={{ marginTop: -30 }} className="campoCheckBox">
                          <InputForm
                            type="checkbox"
                            id="prod_grade"
                            ref="prod_grade"
                            onChange={this.onChange}
                            value={prod_grade}
                            disabled={prod_idf ? true : false}
                          >
                            Estoque em Grade
                          </InputForm>
                        </Col>

                      </Row>
                    </Form>
                  </div>
                </TabPane>


                <TabPane tab="Grade de Produtos" key="grade" disabled={!prod_grade}>
                  <div style={{ height: 270 }}>
                    <Row style={{ marginTop: -10 }}>
                      <Col xs={24}>
                        <Col xs={24} sm={5} style={{ marginRight: 10 }}>
                          <ProdutoTamanhoFrame
                            label="Tamanho"
                            id="pest_tamanho"
                            value={pest_tamanho}
                            width={"100%"}
                            onChange={this.onChangeTamanho}
                          />
                        </Col>
                        <Col xs={24} sm={6} style={{ marginRight: 10 }}>
                          <ProdutoCorFrame
                            label="Cor"
                            id="pest_cor"
                            value={pest_cor}
                            width={"100%"}
                            onChange={this.onChangeCor}
                          />
                        </Col>
                        <Col xs={24} sm={4} style={{ marginTop: 1, marginRight: 10 }}>
                          <span>Qtde Estoque</span>
                          <InputForm
                            type="number"
                            id="pest_qtde"
                            ref="pest_qtde"
                            value={pest_qtde}
                            // disabled={true}
                            onChange={this.onChangeQtdeGrade}
                          />
                        </Col>
                        <Col xs={24} sm={4} style={{ marginTop: 1, marginRight: 10 }}>
                          <span>Estoque Mínimo</span>
                          <InputForm
                            type="number"
                            id="pest_est_minimo"
                            ref="pest_est_minimo"
                            value={pest_est_minimo}
                            // disabled={true}
                            onChange={this.onChangeQtdeGrade}
                          />
                        </Col>
                        <Col xs={24} sm={3} style={{ marginTop: 20, marginRight: 1 }}>
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.onFormIncluirGrade}
                            className="btn-primary"
                          >
                            Incluir Grade
                          </Button>
                        </Col>
                      </Col>
                    </Row>

                    <Table
                      loading={{
                        spinning: carregandoGrade,
                        tip: 'Carregando. Aguarde...',
                        size: "large"
                      }}
                      dataSource={listaGrade}
                      rowKey={(listaGrade => listaGrade.pest_tamanho + '_' + listaGrade.pest_cor)}
                    >
                      <Column
                        key="ptam_descricao"
                        dataIndex="ptam_descricao"
                        title="Tamanho"
                        width={200}
                        align="left"
                        className="listaCadastro"
                      />
                      <Column
                        key="pcor_descricao"
                        dataIndex="pcor_descricao"
                        title="Cor"
                        width={200}
                        align="left"
                        className="listaCadastro"
                      />
                      <Column
                        key="pest_qtde"
                        dataIndex="pest_qtde"
                        title="Qtde Estoque"
                        render={this.renderValor}
                        width={100}
                        align="right"
                        className="listaCadastro"
                      />
                      <Column
                        key="pest_est_minimo"
                        dataIndex="pest_est_minimo"
                        title="Est Mínimo"
                        render={this.renderValor}
                        width={100}
                        align="right"
                        className="listaCadastro"
                      />
                      <Column
                        key="acoes"
                        title=""
                        render={this.renderAcoesGrade}
                        width={70}
                        align="center"
                        className="listaCadastro"
                      />
                    </Table>
                  </div>
                </TabPane>

              </Tabs>
            </div>
          )}

          <div>
            <div className="divider-form" />
            <ItemForm>
              <Row>
                <Col xs={24}>
                  {this.state.visualizar ? null : (
                    <Button
                      type="primary"
                      htmlType="button"
                      loading={carregando}
                      onClick={this.onOK}
                      className="btn-salvar"
                    >
                      Salvar
                    </Button>
                  )}

                  <Button
                    htmlType="button"
                    onClick={onCancelarClick}
                    className="btn-fechar"
                  >
                    Fechar
                  </Button>
                </Col>
              </Row>
            </ItemForm>
          </div>

        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProdutoForm.js